import { render } from "./FooterElement.vue?vue&type=template&id=41ad7250&scoped=true"
import script from "./FooterElement.vue?vue&type=script&lang=js"
export * from "./FooterElement.vue?vue&type=script&lang=js"

import "./FooterElement.vue?vue&type=style&index=0&id=41ad7250&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ad7250"]])

export default __exports__